module.exports = __webpack_public_path__ + "static/media/sip_resumed_illustration_fisdom.61805f6e.svg";